import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

// 请求拦截器
axios.interceptors.request.use(function (config) {
  if (config.url === '/api/login' || config.url === '/api/ssoLogin') { // 非登录请求
    return config
  }
  let token = store.getters.userToken
  if (token) {
    config.data.accessToken = token
  } else {
    if (router && router.query && router.query.accessToken) {
      config.data.accessToken = router.query.accessToken // 尝试url参数中获取
    } else { // 跳转到登录页面
      if (window.config.sessionFailurePolicy === 0) { // 跳转到首页
        router.push({path: '/login'})
      } else if (window.config.sessionFailurePolicy === 1) { // 弹出消息框
        Message.error('尚未登录或会话已过期')
      } else if (window.config.sessionFailurePolicy === 2) { // 静默
      }
    }
  }
  // 显示loading(暂定)
  return config
}, function (error) {
  // 请求错误弹窗提示
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(function (response) {
  // 在数据返回客户端前修改响应数据
  return response.data
}, function (error) {
  return Promise.reject(error)
})

// 成功回调
function successState (res) {
  // 隐藏loading
  // 判断后端返回错误码
  if (res.code >= 400 && res.code <= 600) {
    Message.error(res.msg)
  }

  // 跳转到登录页面
  if (res.code === 401) {
    store.commit('user/SET_TOKEN', '')
    if (window.config.sessionFailurePolicy === 0) { // 跳转到首页
      router.push({path: '/login'})
    } else if (window.config.sessionFailurePolicy === 1) { // 弹出消息框
      Message.error('尚未登录或会话已过期')
    } else if (window.config.sessionFailurePolicy === 2) { // 静默
    }
  }
}

// 失败回调
function errorState (err) {
  // 隐藏loading
  if (err.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(err.response.data)
    console.log(err.response.status)
  } else if (err.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(err.request)
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error: ', err.message)
  }
  // console.log(err.config)
  Message.error(err.message)
}

const httpRequest = (opts, data) => {
  let tempData = {}
  let defaultOpts = {
    method: opts.method,
    url: opts.url,
    timeout: window.config,
    // baseURL: BASE_URL,
    params: opts.method === 'get' || opts.method === 'delete' ? Object.assign(tempData, data) : null,
    data: opts.method === 'post' || opts.method === 'put' ? Object.assign(tempData, data) : null,
    headers: opts.method === 'get' ? {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',

      'Content-Type': 'application/json;charset=UTF-8'
    } : {
      'X-Requested-with': 'XMLHttpRequest',
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  return new Promise((resolve, reject) => {
    axios(defaultOpts)
      .then(res => {
        successState(res)
        resolve(res)
      })
      .catch(err => {
        errorState(err)
        reject(err)
      })
  })
}

// 后台接收通知消息使用的Axios实例
var notificationAxiosInst = null
const notificationHttpRequest = (opts, data) => {
  let tempData = {}
  let defaultOpts = {
    method: opts.method,
    url: opts.url,
    timeout: 90000, // 长轮询，超时为90秒
    // baseURL: BASE_URL,
    params: opts.method === 'get' || opts.method === 'delete' ? Object.assign(tempData, data) : null,
    data: opts.method === 'post' || opts.method === 'put' ? Object.assign(tempData, data) : null,
    headers: opts.method === 'get' ? {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',

      'Content-Type': 'application/json;charset=UTF-8'
    } : {
      'X-Requested-with': 'XMLHttpRequest',
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  defaultOpts.data.accessToken = store.getters.userToken

  return new Promise((resolve, reject) => {
    if (notificationAxiosInst === null) {
      notificationAxiosInst = axios.create(defaultOpts)
    }
    notificationAxiosInst(defaultOpts).then(res => {
      resolve(res.data) // 需要注意：很奇怪但没错，notificationAxiosInst返回的res确实和axios函数返回的确实不同
    }).catch(err => {
      reject(err)
    })
  })
}

export { httpRequest, notificationHttpRequest }



// WEBPACK FOOTER //
// ./src/api/http-request.js